import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type RecentlyUsedRange = {
  start: string;
  end: string;
};

const MAX_RECENTLY_USED = 10;

type RecentlyUsedRangesState = {
  recentlyUsedRanges: RecentlyUsedRange[];
  addRange: (range: RecentlyUsedRange) => void;
};

export const useRecentlyUsedRangesStore = create<RecentlyUsedRangesState>()(
  persist(
    (set) => ({
      recentlyUsedRanges: [],
      addRange: ({ start, end }) =>
        set((state) => ({
          recentlyUsedRanges: [
            { start, end },
            ...state.recentlyUsedRanges.filter(
              (range) => !(range.start === start && range.end === end)
            ),
          ].slice(0, MAX_RECENTLY_USED),
        })),
    }),
    { name: 'autoops.recentlyUsedRanges' }
  )
);
